import React, { useContext } from 'react'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import { CardGroup, CardLine } from '../Elements'

interface PickupAddressProps {
  storeName: string
  storeAddress: string
}

const PickupAddress = ({
  storeName = '',
  storeAddress = ''
}: PickupAddressProps): JSX.Element => {
  const { t } = useContext(TranslationContext)

  return (
    <CardGroup>
      <CardLine heading={t('Store Name')} text={storeName} />
      <CardLine heading={t('Store Address')} text={storeAddress} />
    </CardGroup>
  )
}

export default PickupAddress
